import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, unref as _unref, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "text-red-500 ml-auto flex place-items-center"
}
const _hoisted_4 = {
  key: 1,
  class: "text-red-500 mx-2"
}
const _hoisted_5 = ["value", "placeholder", "autocomplete", "readonly"]
const _hoisted_6 = ["value", "type", "id", "placeholder", "autocomplete", "disabled", "readonly", "max", "min"]

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TextField',
  props: {
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: false,
  },
  type: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    required: false,
  },
  model: {
    type: [String, Number],
    required: false,
  },
  errorMessage: {
    type: String,
    default: "",
  },
  hasError: {
    type: Boolean,
    default: false,
  },
  hideDetails: {
    type: Boolean,
    default: false,
  },
  iconName: {
    type: String,
    required: false,
  },
  autocomplete: {
    type: String,
    required: false,
  },
  isAcopled: {
    type: Boolean,
    required: false,
    default: false,
  },
  compact: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  readonly: {
    type: Boolean,
    required: false,
    default: false,
  },
  saveOnFocus: {
    type: Boolean,
    required: false,
    default: false,
  },
  max: {
    type: Number,
    required: false,
  },
  min: {
    type: Number,
    required: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:model", "dateSuccess"],
  setup(__props, { emit }) {

const props = __props;





const errorMessageStyle = computed(() =>
  props.hasError ? "" : "visibility: hidden"
);
const saveInput = () => {
  emit("dateSuccess");
};
function updateModel(event: Event) {
  if (event.target === null) return;

  if (props.type == "number")
    emit("update:model", Number((event.target as HTMLInputElement).value));
  else emit("update:model", (event.target as HTMLInputElement).value);
}

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass(["flex flex-row items-center text-xs", { 'text-red-500': __props.hasError, 'text-gray-700': !__props.hasError }]),
          for: __props.name
        }, [
          _createTextVNode(_toDisplayString(__props.label) + " ", 1),
          (__props.hideDetails && __props.hasError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_Popper, {
                  arrow: "",
                  class: "font-normal",
                  placement: "auto",
                  hover: "",
                  content: __props.errorMessage
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_mdicon, {
                      name: "error",
                      size: "16"
                    })
                  ]),
                  _: 1
                }, 8, ["content"])
              ]))
            : _createCommentVNode("", true),
          (__props.required)
            ? (_openBlock(), _createElementBlock("label", _hoisted_4, " * "))
            : _createCommentVNode("", true)
        ], 10, _hoisted_2))
      : _createCommentVNode("", true),
    (__props.iconName)
      ? (_openBlock(), _createBlock(_component_mdicon, {
          key: 1,
          class: "absolute ml-2 my-2",
          size: "20",
          name: __props.iconName
        }, null, 8, ["name"]))
      : _createCommentVNode("", true),
    (__props.type == 'textarea')
      ? (_openBlock(), _createElementBlock("textarea", {
          key: 2,
          class: _normalizeClass(["appearance-none border rounded-lg w-full py-2 px-2 leading-tight focus:outline-none hover:border-gray-400", {
        'text-gray-700 border-gray-300 focus:border-black': !__props.hasError,
        'text-red-700 border-red-300 focus:border-red-400': __props.hasError,
      }]),
          value: __props.model,
          onInput: updateModel,
          placeholder: __props.placeholder,
          autocomplete: __props.autocomplete,
          rows: "4",
          readonly: __props.readonly
        }, null, 42, _hoisted_5))
      : (_openBlock(), _createElementBlock("input", {
          key: 3,
          class: _normalizeClass([{
        'p-1 text-sm': __props.compact,
        'p-2': !__props.compact,
        'pl-8': __props.iconName,
        'border-r border-y rounded-lg rounded-l-none': __props.isAcopled,
        'border rounded-lg': !__props.isAcopled,
        'text-gray-700 border-gray-300 focus:border-black': !__props.hasError,
        'text-red-700 border-red-300 focus:border-red-400': __props.hasError,
      }, "appearance-none w-full leading-tight focus:outline-none disabled:border-gray-200 disabled:text-gray-200"]),
          value: __props.model,
          onInput: updateModel,
          type: __props.type,
          id: __props.name,
          placeholder: __props.placeholder,
          autocomplete: __props.autocomplete,
          disabled: __props.disabled,
          readonly: __props.readonly,
          max: __props.max,
          min: __props.min
        }, null, 42, _hoisted_6)),
    (__props.saveOnFocus && __props.model)
      ? (_openBlock(), _createBlock(_component_mdicon, {
          key: 4,
          class: "cursor-pointer absolute ml-2 my-2 rounded-lg text-warning hover:text-green-400 focus:bg-green-400",
          onClick: saveInput,
          name: "content-save-check"
        }))
      : _createCommentVNode("", true),
    (!__props.hideDetails)
      ? (_openBlock(), _createElementBlock("p", {
          key: 5,
          class: "text-red-500 text-xs italic min-h-[16px]",
          style: _normalizeStyle(_unref(errorMessageStyle))
        }, _toDisplayString(__props.errorMessage), 5))
      : _createCommentVNode("", true)
  ]))
}
}

})